import React, { useState, useEffect, useLayoutEffect } from "react";
import Image from "gatsby-image";
import has from "lodash/has";
import { Link } from "gatsby";
import { css } from "@emotion/core";
import { MdKeyboardArrowDown } from "react-icons/md";
import { get } from "lodash";
import { motion } from "framer-motion";
import SecondReusableTiles from "../SecondReusableTiles";
import ParallaxPuppy from "../ParallaxPuppy";
import FeedingGreatness2024 from "../FeedingGreatness2024";
import WinalotReview from "../../images/card-products-animated-2024.gif";
import WinalotReview1 from "../../images/card-winalot-feeding-greatness-2024.png";
import WinalotReview2 from "../../images/card-winalot-review-new2.png";
import WinalotProduct from "../../images/card-winalot-review1-v2.png";

const ITEMS_PER_SLIDE = 20;

function AddWinalotReviewToTheStories(storys) {
  const instances = Math.floor((storys.length - 3) / 12);

  const newArray = [];
  newArray.push(...storys);
  newArray.splice(3, 0, {
    type: "v1",
  });
  if (instances > 0) {
    const versions = ["v2", "v3", "v4", "v1"];
    Array.from({ length: instances }).forEach((_, i) => {
      newArray.splice(3 + 19 * (i + 1), 0, {
        type: versions[i % 4],
      });
    });
  }
  return newArray;
}

function AddCompetitionToTheStories(storys) {
  const instances = Math.floor((storys.length - 3) / 12);
  console.log(instances);
  const newArray = [];
  newArray.push(...storys);
  newArray.splice(13, 0, {
    type: "competition",
  });
  if (instances > 0) {
    Array.from({ length: instances }).forEach((_, i) => {
      newArray.splice(13 + 20 * (i + 1), 0, {
        type: "competition",
      });
    });
  }
  return newArray;
}
export default function FilterListing({
  data,
  title,
  type: filterType,
  filter,
}) {
  const storys = get(data, "nodes");

  const [{ list, page, next }, setState] = useState({
    list: ITEMS_PER_SLIDE,
    page: 1,
    next: storys.length > ITEMS_PER_SLIDE,
  });
  const [offsetY, setOffsetY] = useState(0);
  useEffect(() => {
    if (page > 1) {
      window.pageYOffset = offsetY;
    }
  }, [page]);
  useEffect(() => {
    if (list < storys.length) {
      setState({
        list,
        next: true,
      });
    } else {
      setState({
        list,
        next: false,
      });
    }
  }, [list]);
  return (
    <div className="overflow-x-hidden ">
      <div className="container py-10">
        <h2 className="font-slab font-bold text-2xl text-primary uppercase mb-6 flex items-center">
          <span>{title}</span>{" "}
          <span className="opacity-50 font-normal text-sm pl-4 ">
            [{storys.length} dog{storys.length != 1 ? "s" : ""}]
          </span>
        </h2>{" "}
        <div
          className={`grid gap-4  grid-cols-2 md:grid-cols-4 lg:grid-cols-5`}
          css={css`
            grid-template-rows: min-content;
            @media (min-width: 640px) {
              // max-width:500px;
              // margin:auto;
            }
          `}
        >
          {storys[0] ? (
            AddCompetitionToTheStories(AddWinalotReviewToTheStories(storys))
              .slice(0, list)
              .map(({ type, frontmatter: story }, index) => {
                return (
                  <React.Fragment key={index}>
                    {index !== 0 && index % 20 == 0 && (
                      <motion.div
                        layout
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 1 }}
                        className=" col-span-2 md:col-span-4 lg:col-span-5 "
                        css={css`
                          margin-left: calc((100% - 100vw) / 2);
                          width: 100vw;
                          padding: 15px 0px;
                        `}
                      >
                        <FeedingGreatness2024 />
                      </motion.div>
                    )}

                    {/* every 20 stories show this -- offset it by 4 places */}
                    {(index + 10) % 20 == 0 && (
                      <div
                        className="col-span-2 md:col-span-4 lg:col-span-5"
                        css={css`
                          margin-left: calc((100% - 100vw) / 2);
                          width: 100vw;
                          padding: 15px 0px;
                        `}
                      >
                        <motion.div
                          initial={{ opacity: 0 }}
                          animate={{ opacity: 1 }}
                          exit={{ opacity: 1 }}
                        >
                          <ParallaxPuppy />
                        </motion.div>
                      </div>
                    )}

                    {type ? (
                      type == "competition" ? (
                        <Link
                          to="/doty-voting-2024"
                          className="bg-accent rounded overflow-hidden shadow"
                        >
                          {" "}
                          <div className="p-4">
                            <div className="bg-white text-accent px-2 py-1 leading-none rounded-lg mb-3 text-sm inline-block font-bench  ">
                              COMPETITION
                            </div>
                            <h3 className="font-slab font-bold   text-xl text-white">
                            Want to help crown Dog of the Year 2024? Vote for your favourite now for a chance to win
                            </h3>
                            <div className="text-white font-bench mt-2">
                              VOTE NOW
                            </div>
                          </div>
                        </Link>
                      ) : (
                        <Winalot type={type} />
                      )
                    ) : (
                      <div className="rounded bg-white overflow-hidden shadow relative">
                        {story.tags &&
                          Array.isArray(story.tags) &&
                          story.tags.includes("Class of 19/23") && (
                            <div className="absolute top-0 left-0 z-20 mt-2 ml-2 ">
                              <div className="bg-primary whitespace-no-wrap uppercase leading-none px-2 py-1 mb-2 rounded-lg text-white font-bench inline-block text-sm">
                                Class of 19/23
                              </div>{" "}
                            </div>
                          )}
                        <Link
                          to={`/${story.slug}/`}
                          state={{
                            filterType,
                            filter,
                          }}
                        >
                          {has(story, "thumb.childImageSharp.fluid") && (
                            <Image
                              className="h-40"
                              fluid={story.thumb.childImageSharp.fluid}
                            />
                          )}
                          <div className="p-4">
                            <h3 className="font-slab font-bold text-primary text-lg">
                              {story.subtitle}
                            </h3>
                            <p className="opacity-75">{story.subtitle2}</p>
                          </div>
                        </Link>
                      </div>
                    )}
                  </React.Fragment>
                );
              })
          ) : (
            <div>No dogs in this category</div>
          )}
        </div>
        <div className="pt-10 text-center">
          {next && (
            <button
              onClick={() => {
                setOffsetY(window.pageYOffset - 100);
                setState({
                  list: list + ITEMS_PER_SLIDE,
                  page: page + 1,
                  next,
                });
              }}
              className="bg-primary focus:outline-none text-white font-bench uppercase relative text-xl md:text-3xl py-2 px-20 rounded-full "
            >
              LOAD MORE DOGS{" "}
              <MdKeyboardArrowDown
                className="w-8 h-8 absolute"
                css={css`
                  top: calc(50% - 1rem);
                  right: 1rem;
                `}
              />
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

function Winalot({ type }) {
  // console.log(type);
  if (["v1", "v2", "v3", "v4"].indexOf(type) == -1) {
    return null;
  }
  const versions = {
    v1: {
      image: WinalotReview,
      link:
        "https://bit.ly/3eRimzY",
    },
    v2: {
      image: WinalotReview1,
      link:
        "https://bit.ly/3eQheg6",
    },
    v3: {
      image: WinalotReview2,
      link:
        "https://bit.ly/3qS22EJ",
    },
    v4: {
      image: WinalotProduct,
      link:
        "https://bit.ly/3qS22EJ",
    },
  };

  return (
    <a
      href={versions[type].link}
      className="rounded overflow-hidden text-center relative"
      target="_blank"
    ><img
        src={versions[type].image}
        className="h-auto mx-auto  relative z-10 object-contain object-top"
      /></a>
  );
}
